Vue.component('scroll-to', {
  delimiters: ['[[', ']]'],
  props: {
    target: {
      type: String,
      default: ''
    },
    duration: {
      type: Number,
      default: 1200
    },
    offset: {
      type: Number,
      default: 0
    }
  },
  data: () => {
    return {
    }
  },
  computed: {
    targetId() {
      return `anchor-${this.target}`;
    }
  },
  methods: { 
    scroll() {
      let to = document.getElementById(this.targetId);
      // let element = document.scrollingElement || document.documentElement;
      // let rect = to.getBoundingClientRect();
      VueScrollTo.setDefaults({
          container: "body",
          duration: 600,
          easing: "ease",
          offset: 0,
          force: true,
          cancelable: true,
          onStart: false,
          onDone: false,
          onCancel: false,
          x: false,
          y: true
      })
      VueScrollTo.scrollTo(to);
    }

  },
  mounted() {
  },
  template: `<span @click="scroll()">
    <slot></slot>
</span>`
})